export class MessageData {
  id: string;
  message: string;
  displayName: string;
  avatarUrl: string;
  date: string;
  me?: boolean;

  constructor(
    id: string,
    message: string,
    displayName: string,
    avatarUrl: string,
    date: string,
    me = false
    ) {
    this.id = id;
    this.message = message;
    this.displayName = displayName;
    this.avatarUrl = avatarUrl;
    this.date = date;
    this.me = me;
  }
}
